if (typeof(easy_fancybox_handler) == "function" && !(window.innerWidth < 480 || window.innerHeight < 480 || window.outerWidth < 480 || window.outerHeight < 480 || document.body.clientWidth < 480)) {
    jQuery(document).on('ready post-load', easy_fancybox_handler);
}